import React, { useState } from "react";
import {
  IconButton,
  InputAdornment,
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { StyledTextField } from "./TextField.styles";

export const Password: React.FC<MuiTextFieldProps> = ({
  type,
  label,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const { t } = useTranslation();

  return (
    <StyledTextField
      label={label ?? t("shared.textField.password.label")}
      variant="outlined"
      value={props.value}
      type={showPassword ? "text" : "password"}
      onChange={props.onChange}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={t("shared.textField.password.toggleVisibility")}
              onClick={handleClickShowPassword}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
      {...props}
    />
  );
};
